/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    
    export class ExtensibleComponentConfigurationModel {

        public contracts;
        public componentAssembliesLocation;
        public componentConfigurationsLocation;
        public assemblyLoadedExtensibleComponents;
        public syncActivePackages;
        public useLocalLargeObjectStorage;
        public progress: number;
        public showConfirm: boolean;
        public componentToRemove: Wars.Domain.Model.ExtensibleComponent;


        constructor(
            private $http: angular.IHttpService,
            private Upload,
            private $timeout: angular.ITimeoutService,
            private growlService: angular.growl.IGrowlService) {
            this.loadComponents();
        }        

        private loadComponents() {
            var self = this;
            this.$http.get('./api/ExtensibleComponent/').success((result: any) => {
                self.componentAssembliesLocation = result.componentAssembliesLocation;
                self.componentConfigurationsLocation = result.componentConfigurationsLocation;
                self.assemblyLoadedExtensibleComponents = result.assemblyLoadedExtensibleComponents;
                self.syncActivePackages = result.syncActivePackages;
                self.useLocalLargeObjectStorage = result.useLocalLargeObjectStorage;
                self.contracts = result.extensibleContracts;
                for (var i = 0; i < self.contracts.length; i++) {
                    for (var j = 0; j < self.contracts[i].extensibleComponents.length; j++) {
                        self.contracts[i].extensibleComponents[j].configurationJson = JSON.stringify(JSON.parse(self.contracts[i].extensibleComponents[j].configurationJson), null, "\t");
                    }
                }
            });
        }

        private refresh(contracts: Array<Wars.Domain.Model.ExtensibleContract>) {
            var self = this;
            var currentContracts: Array<Wars.Domain.Model.ExtensibleContract> = self.contracts;
            var contractRemovals = [];
            var componentRemovals = [];
            var i: number;
            var ii: number;
            var contractMatch: Wars.Domain.Model.ExtensibleContract;
            var componentMatch: Wars.Domain.Model.ExtensibleComponent;
            for (i = 0; i < contracts.length; i++) {
                contractMatch = Enumerable.from(currentContracts).where(o => o.id === contracts[i].id).firstOrDefault();
                if (contractMatch == null) {
                    self.contracts.push(contracts[i]);
                } else {
                    for (ii = 0; ii < contracts[i].extensibleComponents.length; ii++) {
                        componentMatch = Enumerable.from(contractMatch.extensibleComponents).where(o => o.id === contracts[i].extensibleComponents[ii].id).firstOrDefault();
                        if (componentMatch == null) {
                            contractMatch.extensibleComponents.push(contracts[i].extensibleComponents[ii]);
                        } else {
                            componentMatch.enabled = contracts[i].extensibleComponents[ii].enabled;
                        }
                    }
                }
            }
            for (i = 0; i < self.contracts.length; i++) {
                contractMatch = Enumerable.from(contracts).where(o => o.id === self.contracts[i].id).firstOrDefault();
                if (contractMatch == null) {
                    contractRemovals.push(self.contracts[i]);
                } else {
                    for (ii = 0; ii < self.contracts[i].extensibleComponents.length; ii++) {
                        componentMatch = Enumerable.from(contractMatch.extensibleComponents).where(o => o.id === self.contracts[i].extensibleComponents[ii].id).firstOrDefault();
                        if (componentMatch == null) {
                            componentRemovals.push(self.contracts[i].extensibleComponents[ii]);
                        }
                    }
                }
            }
            self.contracts = Enumerable.from(self.contracts).except(contractRemovals).toArray();
            for (i = 0; i < self.contracts.length; i++) {
                self.contracts[i].extensibleComponents = Enumerable.from(self.contracts[i].extensibleComponents)
                    .except(componentRemovals)
                    .toArray();    
            }
        }

        public activateComponent(component) {
            var self = this;
            self.$http.post('./api/ExtensibleComponent/Activate', component).success((result: any) => {
                self.refresh(result.extensibleContracts);
            });
        }

        public removeComponent() {
            var self = this;
            if (self.componentToRemove != null) {
                self.$http.post('./api/ExtensibleComponent/Remove', self.componentToRemove).success((result: any) => {
                    self.refresh(result.extensibleContracts);
                    self.cancelConfirm();
                });    
            }
        }

        public saveComponentConfiguration(component) {
            this.$http.post('./api/ExtensibleComponent/Configure', component);
        }

        public uploadFiles(files) {
            var self = this;
            if (files && files.length) {
                self.Upload.upload({
                    url: './api/ExtensibleComponent',
                    data: {
                        files: files
                    }
                }).then(
                    (result) => {
                        if (result != null && result.data != null && result.data.message != null) {
                            self.growlService.info(result.data.message);
                        }
                        self.loadComponents();
                    },
                    () => {
                         /* Let the automatic error handling throw up a growl about unexpected error */
                    },
                    (evt) => {
                        self.progress = Math.min(100, 100.0 * evt.loaded / evt.total);
                    });
            }
        }

        private displayConfirmation(component: Wars.Domain.Model.ExtensibleComponent) {
            var self = this;
            self.showConfirm = true;
            self.componentToRemove = component;
        }

        private cancelConfirm() {
            var self = this;
            self.showConfirm = false;
            self.componentToRemove = null;
        }
    }
}